import React from 'react'
import { useSelector } from 'react-redux'
import Question from '../../Questions'

const Selector = () => {
  const { questions } = useSelector(({ models }) => models)

  const renderQuestion = () => {
    switch (questions) {
      case 1:
        return <Question options={[1, 2, 3]} questionType="QuestionOne" />
      case 2:
        return <Question options={[1, 2, 3]} questionType="QuestionTwo" />
      case 3:
        return <Question options={['Yes', 'No']} questionType="QuestionThree" />
      default:
        return null
    }
  }

  return <div style={{ display: questions >= 4 ? 'none' : 'block' }}>{renderQuestion()}</div>
}

export default Selector
